import { Component, ChangeDetectionStrategy, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { OnDestroyMixin, untilComponentDestroyed } from '@w11k/ngx-componentdestroyed';
import { ListFilterItem, ReportLayoutDefinition, TimeSeriesFilter } from 'app/modules/reporting/reporting.types';
import moment, { Moment } from 'moment';
import { noop, tap } from 'rxjs';

@Component({
  selector: 'app-reporting-builder-filter',
  templateUrl: './filter.component.html',
  styleUrls: ['./filter.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ReportingBuilderFilterComponent extends OnDestroyMixin implements OnInit {
  @Input() definition: ReportLayoutDefinition;
  @Input() filters: { fjson: string; timeSeries: TimeSeriesFilter };
  @Input() isTimeSeries = false;
  @Input() allowRelatedObjectFields = false;
  @Input() fieldsFilterFn;
  @Input() isReportBusy = false;
  @Input() canApplyFilters = true;

  @Output() filterChanged = new EventEmitter<ListFilterItem[]>();
  @Output() timeSeriesfilterChanged = new EventEmitter<TimeSeriesFilter>();

  timeSeriesForm: FormGroup;
  queryFilters: ListFilterItem[];
  isFilterRowsValid: boolean;

  get isTimeSeriesFilterValid(): boolean {
    return this.timeSeriesForm.get('startDate').value?.isValid() && this.timeSeriesForm.get('endDate').value?.isValid();
  }

  constructor() {
    super();
  }

  ngOnInit(): void {
    this.timeSeriesForm = new FormGroup({
      startDate: new FormControl<Moment>(moment(this.filters?.timeSeries?.startDate, 'YYYY-MM-DD')),
      endDate: new FormControl<Moment>(moment(this.filters?.timeSeries?.endDate, 'YYYY-MM-DD')),
    });

    this.timeSeriesForm.valueChanges
      .pipe(
        untilComponentDestroyed(this),
        tap(({ startDate, endDate }) => {
          this.timeSeriesfilterChanged.emit({
            startDate: startDate?.isValid() ? startDate.format('YYYY-MM-DD') : null,
            endDate: endDate?.isValid() ? endDate.format('YYYY-MM-DD') : null,
          });
        }),
      )
      .subscribe(noop);
  }

  onListFilterChanged({ filters, options }: { filters: ListFilterItem[]; options: any }): void {
    this.queryFilters = filters;

    if (filters.length === 0) {
      this.apply();
    }
  }

  onFilterRowsValidityChange(isValid: boolean): void {
    this.isFilterRowsValid = isValid;
  }

  apply(): void {
    if (this.isTimeSeries) {
      this.timeSeriesfilterChanged.emit({
        startDate: this.timeSeriesForm.get('startDate').value?.format('YYYY-MM-DD'),
        endDate: this.timeSeriesForm.get('endDate').value?.format('YYYY-MM-DD'),
      });
    }

    this.filterChanged.emit(this.queryFilters ?? []);
  }

  clear(): void {
    this.queryFilters = [];
    this.timeSeriesForm.reset();
    this.onFilterRowsValidityChange(false);
    this.apply();
  }
}
